import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'year', label: 'Year / Period', type: 'text', placeholder: 'e.g. FY 2024-25 or 2024' },
    { key: 'job_vacancies_posted', label: 'Job Vacancies Posted', type: 'text', placeholder: 'e.g. 22,100' },
    { key: 'candidates_placed', label: 'Candidates Placed', type: 'text', placeholder: 'e.g. 15,600' },
    { key: 'notes', label: 'Notes (optional)', type: 'text', placeholder: 'e.g. YTD, provisional' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'year', label: 'Year', primary: true },
    { key: 'job_vacancies_posted', label: 'Vacancies Posted' },
    { key: 'candidates_placed', label: 'Candidates Placed' },
    { key: 'notes', label: 'Notes' },
];

const defaultItem = { year: '', job_vacancies_posted: '', candidates_placed: '', notes: '', order: 99 };

export default function AdminServiceYearStatsPage() {
    return (
        <CrudManager
            resource="service-year-stats"
            title="Year-wise Employment Statistics"
            description="Shown on the Services page under Employment Services."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['year']}
        />
    );
}
